namespace Nobox.Nobox {
    export interface LeadRow {
        Id?: number;
        Unik?: string;
        Name?: string;
        Category?: string;
        Photo?: string;
        Address?: string;
        LocatedIn?: string;
        Website?: string;
        Rating?: string;
        Reviews?: string;
        Postal?: string;
        Latitude?: string;
        Longitude?: string;
        OpenHours?: string;
        Location?: string;
        ExtSites?: string;
        Url?: string;
        Tool?: string;
        Search?: string;
        ListId?: string;
        Tags?: string;
        Country?: string;
        City?: string;
        State?: string;
        Progress?: number;
        Manager?: string;
        VatNumber?: string;
        Notes?: string;
        In?: string;
        Up?: string;
        LinkId?: number;
        IsBlock?: number;
        User?: Administration.UserRow;
        Custom?: string;
    }

    export namespace LeadRow {
        export const idProperty = 'Id';
        export const nameProperty = 'Name';
        export const localTextPrefix = 'Nobox.Lead';
        export const lookupKey = 'Nobox.Lead';

        export function getLookup(): Q.Lookup<LeadRow> {
            return Q.getLookup<LeadRow>('Nobox.Lead');
        }
        export const deletePermission = 'Contact:Delete';
        export const insertPermission = 'Contact:Modify';
        export const readPermission = 'Contact:View';
        export const updatePermission = 'Contact:Modify';

        export declare const enum Fields {
            Id = "Id",
            Unik = "Unik",
            Name = "Name",
            Category = "Category",
            Photo = "Photo",
            Address = "Address",
            LocatedIn = "LocatedIn",
            Website = "Website",
            Rating = "Rating",
            Reviews = "Reviews",
            Postal = "Postal",
            Latitude = "Latitude",
            Longitude = "Longitude",
            OpenHours = "OpenHours",
            Location = "Location",
            ExtSites = "ExtSites",
            Url = "Url",
            Tool = "Tool",
            Search = "Search",
            ListId = "ListId",
            Tags = "Tags",
            Country = "Country",
            City = "City",
            State = "State",
            Progress = "Progress",
            Manager = "Manager",
            VatNumber = "VatNumber",
            Notes = "Notes",
            In = "In",
            Up = "Up",
            LinkId = "LinkId",
            IsBlock = "IsBlock",
            User = "User",
            Custom = "Custom"
        }
    }
}
